let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2PEGr")).then(() => parcelRequire('9f2DW'));